module.exports = "/_next/static/videos/hockey-2-f573a61387bd6aff41fceb93130aa726.webm";